export const SET_CURSO = 'SET_CURSO';
export const SET_CURSOS = 'SET_CURSOS';
export const UPDATE_CURSOS = 'UDPATE_CURSOS';
export const ADD_CURSOS = 'ADD_CURSOS';
export const REMOVE_CURSOS = 'REMOVE_CURSOS';